import meService from "@/services/meService";

const state = () => ({
  me: null
});

const actions = {
  async getMe({ commit, dispatch }) {
    try {
      const res = await meService.getMe();
      commit("setMe", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Benutzerdaten konnten nicht geladen werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async updatePassword({ dispatch }, { oldPassword, newPassword }) {
    try {
      await meService.updatePassword({ oldPassword, newPassword });
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Passwort konnte nicht aktualisiert werden. Eventuell wurde das momentane Passwort falschgeschrieben.",
        { root: true }
      );
      return Promise.reject();
    }
  }
};

const getters = {};

const mutations = {
  setMe(state, me) {
    state.me = me;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
